module.exports = __webpack_public_path__ + "static/media/Item_Weapon_K2_C.9eb3f0e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_K2_C.png
// module id = 396
// module chunks = 0